import Avatar, { AvatarProps } from '@material-ui/core/Avatar'
import { PathHelper } from '@sensenet/client-utils'
import { User } from '@sensenet/default-content-types'
import { User as SNUser } from '@sensenet/sn-auth-react'
import React, { CSSProperties, FC } from 'react'

export const UserAvatar: FC<{
  user: User | SNUser | null | undefined
  avatarProps?: AvatarProps
  style?: CSSProperties
  repositoryUrl: string
}> = (props) => {
  const avatarUrl = props.user?.Avatar?.Url
  if (avatarUrl) {
    return (
      <Avatar
        src={PathHelper.joinPaths(props.repositoryUrl, avatarUrl)}
        alt={props.user?.DisplayName}
        {...props.avatarProps}
        style={props.style}
      />
    )
  }
  return (
    <Avatar
      {...props.avatarProps}
      style={{
        ...props.avatarProps?.style,
        ...props.style,
      }}>
      {(props.user?.DisplayName && props.user.DisplayName[0])?.toUpperCase() ||
        (props.user?.Name && props.user.Name[0])?.toUpperCase() ||
        'U'}
    </Avatar>
  )
}
